export default class Evaluation {
  constructor({
    id = null,
    student_id = null,
    deadline_id = null,
    evaluation_started = '',
    evaluation_ended = '',
    container_log_path = '',
    container_error = '',
    in_queue = '',
    canceled = '',
    subevaluation_changed = '',
    run_canceled = '',
    subevaluations_passed = '',
    is_manual = false,
    manually_evaluated_at = null,
    run_started_at = null
  }) {
    this.id = id;
    this.student_id = student_id;
    this.deadline_id = deadline_id;
    this.evaluation_started = evaluation_started;
    this.evaluation_ended = evaluation_ended;
    this.container_log_path = container_log_path;
    this.container_error = container_error;
    this.in_queue = in_queue;
    this.canceled = canceled;
    this.subevaluation_changed = subevaluation_changed;
    this.run_canceled = run_canceled;
    this.subevaluations_passed = subevaluations_passed;
    this.is_manual = is_manual;
    this.manually_evaluated_at = manually_evaluated_at;
    this.run_started_at = run_started_at;
}

  // Basic validation for evaluation data
  static validate(evaluationData) {
    if (!evaluationData.student_id) {
      throw new Error('Student ID is required');
    }
    if (!evaluationData.deadline_id) {
      throw new Error('Deadline ID is required');
    }
    if (!evaluationData.evaluation_started) {
      throw new Error('Evaluation started is required');
    }
  }

  // Format date to DD.MM.YYYY HH:MM
  static formatDate(date) {
    if (typeof date !== 'string') {
        if (date instanceof Date && !isNaN(date)) {
            date = date.toISOString();
        } else {
            try {
                date = new Date(date).toISOString();
            } catch (e) {
                console.error('Invalid date:', date);
                return '';
            }
        }
    }
    if (!date) return '';

    const [datePart, timePart] = date.split('T');
    const [year, month, day] = datePart.split('-');
    const [hour, minute] = timePart.split(':').map(part => part.split('.')[0]);

    return `${day}.${month}.${year} ${hour}:${minute}`;
  }
}

export class EvaluationWithRelatedData extends Evaluation {
  constructor({
    deadline = null,
    student = null,
    subevaluations = [],
    ...evaluationData
  }) {
    super(evaluationData);
    this.deadline = deadline;
    this.student = student;
    this.subevaluations = subevaluations;
  }
}

export class EvaluationWithDeadlineAndHomework extends Evaluation {
  constructor({
    deadline = null,
    ...evaluationData
  }) {
    super(evaluationData);
    this.deadline = deadline;
  }
}

export class EvaluationStart {
  constructor({
    homework_id = null,
    subtask_ids = [],
    student_ucos = [],
    all_students = false,
    deadline_id = null,
    manual_evaluation = false,
    hard_evaluation = false
  }) {
    this.homework_id = homework_id;
    this.subtask_ids = subtask_ids;
    this.student_ucos = student_ucos;
    this.all_students = all_students;
    this.deadline_id = deadline_id;
    this.manual_evaluation = manual_evaluation;
    this.hard_evaluation = hard_evaluation;
  }

  // Basic validation for submission data
  static validate(submissionData) {
    if (!submissionData.homework_id) {
      throw new Error('Homework ID is required');
    }
    if (submissionData.subtask_ids.length === 0) {
      throw new Error('At least one subtask ID is required');
    }   
    if (!submissionData.manual_evaluation && !submissionData.deadline_id) {
      throw new Error('Deadline ID is required if manual evaluation is not selected');
    }
    if (!submissionData.all_students && submissionData.student_ucos && submissionData.student_ucos.length <= 1 && submissionData.student_ucos[0] === "") {
      throw new Error('At least one student UCO is required if not All students are selected');
    } else {
      for (let uco of submissionData.student_ucos) {
        if (!uco || (uco && uco.trim() === '') || isNaN(uco)) {
          throw new Error('Please enter all valid student UCOs.');
        }
      }
    }
  }
}